import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("saloon_dash_User_Id"),
        token: localStorage.getItem("saloon_dash_Token"),
        usertype: localStorage.getItem("saloon_dash_User_Type"),
        name: localStorage.getItem("saloon_dash_User_name"),
        image: localStorage.getItem("saloon_dash_userImg"),
        phone: localStorage.getItem("saloon_dash_userPhone"),
        email: localStorage.getItem("saloon_dash_userEmail"),
        gender: localStorage.getItem("saloon_dash_userGender"),
        permissions: localStorage.getItem("saloon_dash_permissions"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
